import React from 'react'

import facebookLogo from '../images/facebook-letter-logo.svg'
import instagramLogo from '../images/instagram-logo.svg'
import linkedinLogo from '../images/linkedin-logo.svg'

export default function () {

    return (
        <div id="contato" className="jumbotron jumbotron-fluid m-0 p-0 pt-4 text-white text-center"
            style={{ backgroundColor: "rgb(68, 1, 91)" }}>


            <div className="container row d-flex justify-content-around mx-auto">
                <div>
                    <h5>Endereço</h5>
                    <p>
                        Av. José de Freitas Queiroz, 5003 <br />
                Cedro – Quixadá – Ceará 63902-580
              </p>
                </div>

                <div>

                    <h5>Fale Conosco</h5>
                    <p>
                        projetos@quixada.ufc.br <br />
                (88) 3412 - 0919
              </p>
                </div>

                <div>
                    <h5>Siga-nos</h5>
                    <div className="row mx-auto d-flex justify-content-between mt-3">
                        <a href="https://www.facebook.com/inoveufc/" target="_blank" rel="noopener noreferrer">
                            <img className="footer-logo" alt="facebook logo" src={facebookLogo} width="15px" height="30" />
                        </a>

                        <a href="https://www.instagram.com/inove_ufcquixada/" target="_blank" rel="noopener noreferrer">
                            <img className="footer-logo" alt="instagram logo" src={instagramLogo} width="30px" height="30" />
                        </a>

                        <a href="https://www.linkedin.com/company/inove-ufc-quixada/" target="_blank" rel="noopener noreferrer">
                            <img className="footer-logo" alt="linkedin logo" src={linkedinLogo} width="30px" height="30" />
                        </a>
                    </div>
                </div>
            </div>
            <hr className="w-75 bg-white" />
            <footer>© Copyright 2018. Todos os direitos reservados. INOVE.</footer>
        </div>
    );
}